import React from 'react';
import "./BingoCard.css";


type BingCardType = {
  cardId: number,
  numbers: (number | null)[],
  pickedNumbersInCard?: number[]
}

const BingoCard = React.memo(function BingoCard({ cardId, numbers, pickedNumbersInCard = [] }: BingCardType) {

  return (
    <div className='card'>
      <CardHeader cardId={cardId} />
      <CardNumberTable numbers={numbers} pickedNumbersInCard={pickedNumbersInCard} cardId={cardId} />
    </div>
  );
})

export default BingoCard;



function CardNumberTable({ numbers, pickedNumbersInCard, cardId }: { numbers: (number | null)[], pickedNumbersInCard: number[], cardId: number }) {
  const pickedNums = new Set(pickedNumbersInCard);
  
  return (
    <div className='card-table'>
      {
        numbers.map((num, numI) => {
          const isPicked = pickedNums.has(num || 0);
          return (
            <div
              key={`card-cell-${cardId}-${numI}`}
              className={`card-cell ${isPicked ? "picked-number" : ""}`}>
              {num != null ? num : ""}
            </div>
          )
        })
      }
    </div>
  )
}


function CardHeader({ cardId }: { cardId: number }) {
  return (
    <div className='card-header'>
      <div className='card-logo-con'>
        <img src="./assets/images/logo.png" alt="bingo logo" className='card-logo' />
      </div>
      <div className='card-number'>{cardId}</div>
    </div>
  )
}
